<template>
    <div>
        <div class="serive" :class="['serive-' + device]">
            <div class="top" @click="serviceHandler" style="display: none;">
                <img src="../assets/img/service@2x.png" class="kfico" />
                <div class="name" :class="['name-' + $i18n.locale]">
                    {{ $t('OnlineConsultant') }}
                </div>
            </div>
            <div class="bottom">
                <div class="phoneitem" v-if="systemInfo && systemInfo.phone">
                    <img src="../assets/img/phone@2x.png" class="phone" />
                    <div class="name" :class="['name-' + $i18n.locale]"> {{ $t('ContactUs') }}</div>
                    <div class="phoneitemwrap">
                        {{ $t('ContactUs') }}: {{ systemInfo.phone }}
                    </div>
                </div>
                <div class="phoneitem" v-if="systemInfo && systemInfo.extend1">
                    <img src="../assets/img/qr@2x.png" class="phone" />
                    <div class="name">{{ $t('EnterpriseWeChat') }}</div>
                    <div class="wxitemwrap">
                        <img :src="systemInfo.extend1" class="cover" />
                    </div>
                </div>
                <img src="../assets/img/top@2x.png" @click="scrollToTop" class="gotoico" />
            </div>

        </div>
        <div v-if="dialog" class="online-service-dialog"
            :class="[dialogFlag ? 'animate__animated animate__zoomIn' : 'animate__animated animate__zoomOut']">
            <div class="online-headers">
                <img src="../assets/img/avatar@2x.png" class="avatar" />
                <span class="online-headers-title">{{ $t('OnLineService') }}</span>
                <img src="../assets/img/close@2x.png" class="close" @click="closeHandler" />
            </div>
            <div class="online-body" ref="chatContainer">
                <div class="online-body-item" :class="[!item.left ? 'online-body-item-right' : '']"
                    v-for="(item, index) in listMessage" :key="index">
                    <img src="../assets/img/avatar@2x.png" class="avatar">
                    <div class="online-content">
                        <div class="row-top">
                            <div>{{ item.left ? $t('ClienteleServices') : $t('Me') }}</div>
                            <div>{{ item.loginTime }}</div>
                        </div>
                        <div class="row-content">
                            {{ item.msg }}
                        </div>
                    </div>

                </div>
            </div>
            <div class="online-footer">
                <v-textarea solo name="input-7-1" rows="2" :placeholder="$t('PleaseEnter')"
                    v-model="message"></v-textarea>
                <div class="online-send" @click="sendHandler">
                    {{ $t('Send') }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
// import { parseTime } from '@/utils/ruoyi';
export default {
    directives: {
        draggable: {
            bind(el) {
                let originX, originY, mouseMoveListener, mouseUpListener;
                el.style.cursor = 'move'; // 设置鼠标样式为移动指针
                mouseMoveListener = function (e) {
                    e.preventDefault(); // 阻止默认事件，例如文本选择等
                    let xOffset = e.clientX - originX; // 计算新的x位置
                    let yOffset = e.clientY - originY; // 计算新的y位置
                    el.style.transform = `translate(${xOffset}px, ${yOffset}px)`; // 应用新的位置
                };
                mouseUpListener = function () { // 鼠标释放时移除监听器并重置cursor样式
                    document.removeEventListener('mousemove', mouseMoveListener);
                    document.removeEventListener('mouseup', mouseUpListener);
                    el.style.cursor = 'auto'; // 重置鼠标样式为默认样式或根据需要设置其他样式
                };
                el.addEventListener('mousedown', function (e) { // 鼠标按下时设置初始位置并添加监听器
                    originX = e.clientX; // 记录初始x位置
                    originY = e.clientY; // 记录初始y位置
                    document.addEventListener('mousemove', mouseMoveListener); // 添加鼠标移动监听器以更新位置
                    document.addEventListener('mouseup', mouseUpListener); // 添加鼠标释放监听器以移除监听器并重置样式和位置（如果有需要的话）
                });
            }
            //   bind(el) {
            //     console.log(el)
            //     el.onmousedown = function(e) {
            //         console.log(e,'e===')
            //       let offsetX = e.clientX - el.getBoundingClientRect().left;
            //     //   let offsetY = e.clientY - el.getBoundingClientRect().top;

            //       function mouseMoveHandler(e) {
            //         el.style.cursor = 'pointer';
            //         el.style.left = (e.clientX - offsetX) + 'px';
            //         el.style.top = (e.clientY ) + 'px';
            //       }

            //       function mouseUpHandler() {
            //         document.removeEventListener('mousemove', mouseMoveHandler);
            //         document.removeEventListener('mouseup', mouseUpHandler);
            //       }

            //       document.addEventListener('mousemove', mouseMoveHandler);
            //       document.addEventListener('mouseup', mouseUpHandler);
            //     };
            //   }
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
    },
    name: 'ServieVue',
    data() {
        return {
            maxTime:null,
            clientUuid: '',
            systemInfo: {
                phone: ''
            },
            dialogFlag: false,
            dialog: false,
            message: '',
            listMessage: [],
            timer:null

        }
    },
    watch: {
        listMessage() {
            // this.scrollToBottom();
        }
    },
    mounted() {
      
        this.systemInfo = JSON.parse(localStorage.getItem('systemObj'))
        this.$Bus.$off('updateServiceSystem')
        this.$Bus.$on('updateServiceSystem', () => {
            this.systemInfo = JSON.parse(localStorage.getItem('systemObj'))
        })
    },
    destroyed(){
        this.delMesInt()
    },
    methods: {
        initMes(){
            this.delMesInt()
            this.timer = setInterval(()=>{
                this.getList()
            },2000)
        },
        delMesInt(){
            clearInterval(this.timer)
            this.timer = null
        },
        closeHandler() {
            this.dialogFlag = false
            this.maxTime = null
            this.delMesInt()
            setTimeout(() => {
                this.dialog = false
            }, 300)

        },
        sendHandler() {
            if (this.message.length) {
                this.Api.homeOnlineSend({ uuid: this.clientUuid, msg: this.message }).then((result) => {
                    if (result.code == 200) {
                        this.message = ''
                    }
                    this.delMesInt()
                    this.initMes()
                })
            }
        },
        scrollToBottom() {
            const container = this.$refs.chatContainer;
            container.scrollTop = container.scrollHeight + 150;
        },
        serviceHandler() {
            var clientUuid = localStorage.getItem('clientUuid')
            if (!clientUuid) {
                clientUuid = uuidv4()
            }
            localStorage.setItem('clientUuid', clientUuid)
            this.clientUuid = clientUuid
            this.dialogFlag = true
            this.dialog = true
            this.delMesInt()
            this.initMes()
        },
        getList() {
            var data = {uuid: this.clientUuid}
            if(this.maxTime){
                data.maxTime = this.maxTime
            }
            this.Api.homeOnlineDefault(data).then((result) => {
                if (result.code == 200) {
                    
                    var mes = result.data && result.data.msgVOS && result.data.msgVOS.length ? result.data.msgVOS : []
                    mes.forEach((item) => {
                        if (item.extend1 == 1) {
                            item.left = true
                        } else {
                            item.left = false
                        }
                    })
                    
                    if(this.listMessage.length == 0){
                        this.listMessage = mes
                    }else{
                        let loginTimeList = this.listMessage.map(item =>{
                            return item.loginTime
                        })
                        mes.forEach(item =>{
                            if(!loginTimeList.includes(item.loginTime)){
                                this.listMessage.push(item)
                            }
                        })
                        //  = this.listMessage.concat(mes)
                    }
                    console.log(mes,'mes')
                    if(mes.length){
                        this.maxTime = mes[mes.length - 1]['loginTime']
                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 30)
                    }
                }
            }).catch(() => {
                // 接口异常时停止轮询，避免每2秒重复弹出错误提示
                this.delMesInt()
            })
        },
        scrollToTop() {
            const curPosition = document.documentElement.scrollTop || document.body.scrollTop;
            if (curPosition > 0) {
                window.requestAnimationFrame(this.scrollToTop); // 调用自己
                window.scrollTo(0, curPosition - curPosition / 10);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.serive {
    position: fixed;
    z-index: 2000;
    right: 90px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    .top {
        width: 56px;
        height: 148px;
        background: #164690;
        border-radius: 50px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .kfico {
            width: 31px;
            height: 25px;
        }

        .name {
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 24px;
            text-align: center;
        }

        .name-zh-CN {
            width: 31px;
        }
    }

    .bottom {
        width: 56px;
        height: 182px;
        border-radius: 50px;
        background: #FFFFFF;
        box-shadow: 0px 3px 10px 1px #ECF1FD;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .phoneitem {
            position: relative;
            padding-bottom: 15px;
            padding-top: 15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;

            .phoneitemwrap {
                position: absolute;
                display: none;
                right: 60px;
                top: 0;
                min-width: 220px;
                height: 60px;
                background-color: white;
                font-size: 16px;
                padding: 0 20px;
                box-sizing: border-box;
                white-space: nowrap;
                line-height: 60px;
                font-weight: bold;
                text-align: center;
                border-radius: 10px;
            }

            .wxitemwrap {
                display: none;
                position: absolute;
                right: 60px;
                top: 0;
                width: 220px;
                height: 220px;
                background-color: white;
                border-radius: 10px;
                padding: 20px;
                box-sizing: border-box;
                overflow: hidden;

                .cover {
                    width: 100%;
                    height: 100%;
                }

            }

            .phone {
                width: 18px;
                height: 18px;

            }

            .name {
                font-weight: 400;
                font-size: 10px;
                color: #999999;
            }
        }

        .phoneitem:nth-child(1):hover {
            .phoneitemwrap {
                display: block;
            }
        }

        .phoneitem:nth-child(2):hover {
            .wxitemwrap {
                display: block;
            }
        }

        .phoneitem::after {
            position: absolute;
            content: '';
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            width: 27px;
            border: 1px solid rgba($color: #ECECEC, $alpha: 1);
        }

        .gotoico {
            margin-top: 15px;
            width: 18px;
            height: 16px;
        }
    }
}

.serive-mobile {
    right: 0.3rem;

    .top {
        width: 1.12rem;
        height: 2.96rem;
        border-radius: 1rem;
        margin-bottom: 0.2rem;

        .kfico {
            width: 0.62rem;
            height: 0.5rem;
        }

        .name {
            font-size: 0.32rem;
            line-height: 0.48rem;
        }

        .name-zh-CN {
            width: 0.62rem;
        }

    }

    .bottom {
        width: 1.12rem;
        height: 3.64rem;
        border-radius: 1rem;

        .phoneitem {
            padding-bottom: 0.3rem;
            padding-top: 0.3rem;

            .phoneitemwrap {
                right: 1.2rem;
                min-width: 4.4rem;
                height: 1.2rem;
                font-size: 0.32rem;
                padding: 0 0.4rem;
                line-height: 1.2rem;
                border-radius: 0.2rem;
            }

            .wxitemwrap {
                right: 1.2rem;
                width: 4.4rem;
                height: 4.4rem;
                border-radius: 0.2rem;
                padding: 0.4rem;
            }

            .phone {
                width: 0.36rem;
                height: 0.36rem;
            }

            .name {
                font-size: 0.20rem;
            }
        }

        .phoneitem::after {
            width: 0.54rem;
        }

        .gotoico {
            margin-top: 0.3rem;
            width: 0.36rem;
            height: 0.32rem;
        }
    }
}
</style>
<style lang="scss">
.online-service-dialog {
    position: fixed;
    z-index: 2000000;
    right: 160px;
    top: 50%;
    transform: translateY(-50%);
    width: 566px;
    height: 695px;
    border-radius: 11px;
    background: #F6F6F6;
    overflow: hidden;
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1),
        -4px -4px 12px rgba(0, 0, 0, 0.08);

    .online-headers {
        width: 100%;
        height: 80px;
        background: #164690;
        border-radius: 11px 11px 0px 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 22px;
        box-sizing: border-box;

        .avatar {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            box-sizing: border-box;
            margin-right: 10px;
        }

        .online-headers-title {
            flex: 1;
            font-weight: 500;
            font-size: 22px;
            color: #FFFFFF;
            text-align: left;
        }

        .close {
            width: 31px;
            height: 31px;
        }
    }

    .online-body {
        width: 100%;
        height: 454px;
        background: #F6F6F6;
        padding: 22px;
        box-sizing: border-box;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-bottom: 120px;

        .online-body-item {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin-bottom: 65px;

            .avatar {
                width: 35px;
                height: 35px;

            }

            .online-content {
                width: calc(100% - 48px);
                display: flex;
                flex-direction: column;
                padding-left: 13px;
                box-sizing: border-box;

                .row-top {
                    font-weight: 400;
                    font-size: 16px;
                    color: #707F94;
                    margin-bottom: 16px;
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    div:nth-child(1) {
                        margin-right: 13px;
                    }
                }

                .row-content {
                    width: 100%;
                    line-height: 34px;
                    background: #DCE9F3;
                    font-weight: 400;
                    font-size: 17px;
                    color: #404B60;
                    padding: 10px;
                    box-sizing: border-box;
                    border-radius: 7px 7px 7px 7px;
                }
            }
        }

        .online-body-item-right {
            flex-direction: row-reverse;

            .online-content {
                padding-left: 0px;
                padding-right: 13px;

                .row-top {
                    justify-content: flex-end;
                }

                .row-content {
                    background: #164690;
                    color: white
                }
            }
        }
    }

    .online-footer {
        height: 161px;
        width: 100%;
        background: #FFFFFF;
        border-radius: 0px 0px 11px 11px;
        padding: 0 15px 15px 15px;
        box-sizing: border-box;

        .v-textarea {
            resize: none;

            textarea {
                padding-right: 5px !important;
                resize: none;
            }
        }

        .v-text-field__details {
            display: none;
        }

        .v-input__slot {
            box-shadow: unset !important;
        }

        .online-send {
            margin-top: 15px;
            width: 85px;
            text-align: center;
            line-height: 38px;
            height: 38px;
            background: #164690;
            border-radius: 6px 6px 6px 6px;
            font-weight: 400;
            font-size: 17px;
            color: #FFFFFF;
            margin-left: auto;
            cursor: pointer;
        }
    }
}
</style>